import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useAuth } from '../context/AuthContext';
import './AuthPages.css';

const MerchantLogin = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { login, currentUser } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (currentUser) {
      if (currentUser.role === 'ADMIN') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    }
  }, [currentUser, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSubmitted(true);

    const result = await login(formData.username, formData.password, 'MERCHANT');
    
    if (result.success) {
      // Navigation will be handled by useEffect
    } else {
      // Show lockout message with emphasis if account is locked
      if (result.error && result.error.includes('locked')) {
        setError('🔒 ' + result.error);
      } else {
        setError(result.error);
      }
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo-text">
            <img src="/images/clickpay_logo.png" alt="ClickPay - Secure Payment Gateway" className="auth-logo" />
          </div>
          <h1>Merchant Login</h1>
          <p>Access your merchant dashboard</p>
        </div>
        
        {error && (
          <div id="merchant-login-error" className="alert alert-danger" role="alert" aria-live="assertive">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter your username"
              required
              aria-required="true"
              aria-invalid={submitted && !!error}
              aria-describedby={submitted && error ? 'merchant-login-error' : undefined}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
              placeholder="Enter your password"
              required
              aria-required="true"
              aria-invalid={submitted && !!error}
              aria-describedby={submitted && error ? 'merchant-login-error' : undefined}
            />
            <span
             onClick={() => setShowPassword(!showPassword)}
             style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer"
             }}
             >
              {showPassword ? <FiEye size={18} /> : <FiEyeOff size={18} />}
            </span>
          </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
            aria-busy={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="auth-links">
          <p>
            Don't have a merchant account? 
            <Link to="/merchant/signup"> Sign up here</Link>
          </p>
          <p>
            <Link to="/">← Back to home</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MerchantLogin;